export default __webpack_public_path__ + "static/media/Steps-1-2-3.b4acf50f.gif";